import PropTypes from 'prop-types';
import React from 'react';
import { Box } from 'reflexbox';

import {
  Textarea,
} from 'rebass';

import {
  ToggleView,
} from 'frontend/components';

const SimcNotifications = ({ notifications }) => (
  <Box>
    <ToggleView open={false} label="SimC Notifications">
      <Textarea
        name="simcNotifications"
        label=""
        value={notifications.join('\n')}
        rows={10}
        backgroundColor="rgba(255,255,255,.45)"
        readOnly
        mb={0}
        style={{
          fontSize: 13,
        }}
      />
    </ToggleView>
  </Box>
);

SimcNotifications.propTypes = {
  notifications: PropTypes.array.isRequired,
};

export default SimcNotifications;
